import { CharityRoundingTypeDTO } from "../interfaces/charity-rounding-dtos";
import { CharityRoundingType } from "../../src/models/charity-rounding/interfaces/charityRoundingType";
import { MappedRoundingDataDTO } from "../interfaces/charity-rounding-dtos";
import { RoundingData } from "../../src/models/charity-rounding/interfaces/roundingData";

/**
 * Mao Charity Rounding types into internal representation
 *
 * @param {CharityRoundingTypesDTO} charityRoundingTypes API schema for charity rounding types
 *
 * @return {CharityRoundingType} IW internal charity rounding type schema
 *
 * Note: only first occurrance of CharityRoundingTypesDTO will be used
 *
 * */

export const mapCharityRoundingTypes = (charityRoundingTypes: CharityRoundingTypeDTO[]): CharityRoundingType => {
  if (!charityRoundingTypes || !charityRoundingTypes.length)
    return {
      enabled: false,
      precision: 0,
      message: "",
      title: "",
      hash: ""
    };
  return {
    enabled: charityRoundingTypes[0].enabled,
    precision: charityRoundingTypes[0].precision,
    message: charityRoundingTypes[0].message,
    title: charityRoundingTypes[0].title,
    hash: charityRoundingTypes[0].hash
  };
};

export const mapRoundingData = (roundingData: RoundingData): MappedRoundingDataDTO => {
  if (!roundingData.roundUpForCharity) {
    return {
      amount: 0,
      is_round_up_for_charity: false,
      hash: ""
    };
  }
  return {
    amount: roundingData.amount,
    is_round_up_for_charity: true,
    hash: roundingData.hash
  };
};
